// extracted by mini-css-extract-plugin
export default {"wrap":"ReadingTime_wrap__bvppG","icon":"ReadingTime_icon__KN-t2","text":"ReadingTime_text__1Hejz"};